import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector (Stroke)"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2001 14.2H14.2V20.2H6.80005V14.2H0.800049V6.79999H6.80005V0.799988H14.2V6.79999H20.2001V14.2ZM12.5 8.49999V2.49999H8.50005V8.49999H2.50005V12.5H8.50005V18.5H12.5V12.5H18.5V8.49999H12.5Z"
      fill="#222A5C"
    />
  </svg>,
  "Integration"
);
